import { AtClickable, AtIcon, AtText } from '@/components/atoms';
import {
  TClickableSize,
  EClickableTarget,
  EClickableVariants,
} from '@/components/atoms/at-clickable/at-clickable.types';
import { MlAccordionItem, MlCopyBlock } from '@/components/molecules';
import {
  EBlockAlignment,
  EThemes,
} from '@/lib/contentstack-sdk/types/component';
import { OrFaqList } from './or-faq-list';
import { RenderRichText } from '@/components/helpers/cms/RenderRichText';
import { EIcons } from '@/components/atoms/at-icon/icons';
import atClickable from '@/components/atoms/at-clickable/at-clickable.variants';
import { TOrContentBlockFAQCS } from './or-faq-list.types';

export const OrFaqListCS = ({ block }: TOrContentBlockFAQCS) => {
  if (!block) return null;

  const {
    theme: { theme },
    left_content,
    right_content,
    top_spacing,
    bottom_spacing,
  } = block;

  const RenderLeftContent = () => {
    return (
      <>
        {left_content.length > 0 ? (
          <>
            {left_content.map((items) => {
              const {
                block_header,
                title,
                description,
                link,
                uid,
                alignment,
                heading_element,
                heading_variant,
                eyebrow,
                subhead,
              } = items;

              const {
                size,
                icon,
                outline,
                target,
                url: { title: label, href },
                variant,
                type,
                aria_label,
              } = link;

              const iconName = icon?.[0]?.name?.icon;
              const iconPosition = icon?.[0]?.select?.iconPosition;
              const currentIcon = iconName as EIcons;
              const currentTarget = target as keyof typeof EClickableTarget;
              const currentVariant = variant as keyof typeof EClickableVariants;
              const renderIcon =
                icon &&
                icon.length > 0 &&
                EClickableTarget[currentTarget] !== EClickableTarget.BLANK;
              const { iconColor } = atClickable({
                type,
                intent: EClickableVariants[currentVariant],
                outline,
              });
              return (
                <MlCopyBlock
                  header={block_header}
                  title={title}
                  key={uid}
                  eyebrow={eyebrow}
                  subhead={subhead}
                  titleElement={heading_element?.select || 'h2'}
                  titleVariant={
                    heading_variant?.select || heading_element?.select || 'h2'
                  }
                  alignment={EBlockAlignment[alignment?.alignmentprop]}
                >
                  <RenderRichText body={description} />
                  <AtClickable
                    variant={EClickableVariants[currentVariant]}
                    size={size.toLowerCase() as TClickableSize}
                    label={label}
                    href={href}
                    iconPosition={iconPosition}
                    outline={outline}
                    type={type}
                    target={EClickableTarget[currentTarget]}
                    ariaLabel={aria_label}
                    interactLocation="or-faq-list"
                  >
                    {renderIcon && (
                      <AtIcon color={iconColor()} icon={currentIcon} />
                    )}
                  </AtClickable>
                </MlCopyBlock>
              );
            })}
          </>
        ) : (
          <AtText className="text-skin-error">
            Please add a Copy Block instance
          </AtText>
        )}
      </>
    );
  };

  return (
    <OrFaqList
      theme={EThemes[theme]}
      RenderLeftContent={RenderLeftContent}
      topSpacing={top_spacing?.spacing_value}
      bottomSpacing={bottom_spacing?.spacing_value}
      topDivider={top_spacing?.divider}
      bottomDivider={bottom_spacing?.divider}
    >
      {right_content?.length > 0 ? (
        <>
          {right_content?.[0]?.items?.map((props, index) => {
            const { title, body } = props.accordion_item;
            return (
              <MlAccordionItem key={index} index={index} title={title}>
                <RenderRichText body={body} />
              </MlAccordionItem>
            );
          })}
        </>
      ) : (
        <AtText className="text-skin-error">
          Please add an accordion instance
        </AtText>
      )}
    </OrFaqList>
  );
};
